export default "__VITE_ASSET__DDhHIPJI__"